"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _root_model = _interopRequireDefault(require("./root_model"));
var _user = _interopRequireDefault(require("./user"));
var _user_card = _interopRequireDefault(require("./user_card"));
var _deck_basic = _interopRequireDefault(require("./deck_basic"));
var _user_deck_basic = _interopRequireDefault(require("./user_deck_basic"));
var _serializer_helpers = require("./utils/serializer_helpers");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var UserDeck = (_dec = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec2 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec3 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec4 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_user_card["default"]))), _dec5 = (0, _serializr.serializable)((0, _serializr.object)(_deck_basic["default"])), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_user_deck_basic["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function UserDeck() {
    var _this;
    _classCallCheck(this, UserDeck);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserDeck, [].concat(args));
    // also a user_deck_basic.js
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    // was set without observable?
    _initializerDefineProperty(_this, "rating", _descriptor2, _this);
    _initializerDefineProperty(_this, "currentCardId", _descriptor3, _this);
    _initializerDefineProperty(_this, "finished", _descriptor4, _this);
    _initializerDefineProperty(_this, "designateAsFinished", _descriptor5, _this);
    _initializerDefineProperty(_this, "deckId", _descriptor6, _this);
    _initializerDefineProperty(_this, "userId", _descriptor7, _this);
    _initializerDefineProperty(_this, "progressCurrent", _descriptor8, _this);
    _initializerDefineProperty(_this, "progressTotal", _descriptor9, _this);
    _initializerDefineProperty(_this, "convertToRegistration", _descriptor0, _this);
    _initializerDefineProperty(_this, "convertToPro", _descriptor1, _this);
    _initializerDefineProperty(_this, "guestUser", _descriptor10, _this);
    _initializerDefineProperty(_this, "registeredUser", _descriptor11, _this);
    _initializerDefineProperty(_this, "proUser", _descriptor12, _this);
    _initializerDefineProperty(_this, "finishedGuestUser", _descriptor13, _this);
    _initializerDefineProperty(_this, "finishedRegisteredUser", _descriptor14, _this);
    _initializerDefineProperty(_this, "finishedProUser", _descriptor15, _this);
    _initializerDefineProperty(_this, "finishedMatch", _descriptor16, _this);
    _initializerDefineProperty(_this, "points", _descriptor17, _this);
    _initializerDefineProperty(_this, "lost", _descriptor18, _this);
    _initializerDefineProperty(_this, "won", _descriptor19, _this);
    _initializerDefineProperty(_this, "tied", _descriptor20, _this);
    _initializerDefineProperty(_this, "firstPlaythrough", _descriptor21, _this);
    _initializerDefineProperty(_this, "lastCardType", _descriptor22, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor23, _this);
    _initializerDefineProperty(_this, "updatedAt", _descriptor24, _this);
    _initializerDefineProperty(_this, "user", _descriptor25, _this);
    _initializerDefineProperty(_this, "userCards", _descriptor26, _this);
    _initializerDefineProperty(_this, "deck", _descriptor27, _this);
    _initializerDefineProperty(_this, "opponentUserDeck", _descriptor28, _this);
    return _this;
  }
  _inherits(UserDeck, _RootModel);
  return _createClass(UserDeck, [{
    key: "currentUserCard",
    get: function get() {
      var _this2 = this;
      return (0, _lodash.isEmpty)(this.userCards) || !this.currentCardId ? {} : this.userCards.find(function (item) {
        return item.cardId === _this2.currentCardId;
      });
    }
  }, {
    key: "hasUserCards",
    get: function get() {
      return (0, _utils.isPresent)(this.userCards);
    }
  }, {
    key: "currentPosition",
    get: function get() {
      if ((0, _utils.isPresent)(this.currentUserCard)) {
        return this.currentUserCard.position;
      }
      return null;
    }
  }, {
    key: "deckPercentage",
    get: function get() {
      return Math.floor(this.progressCurrent / this.userCardsCount * 100);
    }
  }, {
    key: "activeUserCards",
    get: function get() {
      return this.userCards.filter(function (item) {
        return item.active;
      });
    }
  }, {
    key: "numActiveUserCards",
    get: function get() {
      return this.activeUserCards.length;
    }
  }, {
    key: "numUserCards",
    get: function get() {
      return this.userCards.length;
    }
  }, {
    key: "completedUserCardsCount",
    get: function get() {
      return this.userCards.filter(function (item) {
        return item.completed;
      }).length;
    }
  }, {
    key: "completedLearningUserCardsCount",
    get: function get() {
      return this.userCards.filter(function (item) {
        return item.completed && item.cardRule.cardType.learningCard;
      }).length;
    }
  }, {
    key: "cardIdForNextActiveUserCardWithWrapping",
    get: function get() {
      // Review Decks don't cycle cards by card type until complete
      if ((0, _utils.isPresent)(this.laterPositionLearningUserCard)) {
        return this.laterPositionLearningUserCard.cardId;
      }
      if ((0, _utils.isPresent)(this.firstActiveUserCard) && this.firstActiveUserCard.id !== this.currentUserCard.id) {
        return this.firstActiveUserCard.cardId;
      }
      if ((0, _utils.isPresent)(this.laterPositionUserCard)) {
        return this.laterPositionUserCard.cardId;
      }
      return null;
    }
  }, {
    key: "cardIdForNextActiveUserCardWithWrappingByCardType",
    get: function get() {
      var _this$currentUserCard, _this$currentUserCard2;
      // Decks other than review decks cycle cards by card type until complete
      if ((0, _utils.isPresent)((_this$currentUserCard = this.currentUserCard) === null || _this$currentUserCard === void 0 ? void 0 : _this$currentUserCard.cardRule) && !((_this$currentUserCard2 = this.currentUserCard.cardRule) !== null && _this$currentUserCard2 !== void 0 && _this$currentUserCard2.cycleCardsUntilCorrect) && (0, _utils.isPresent)(this.laterPositionUserCard)) {
        return this.laterPositionUserCard.cardId;
      }
      if ((0, _utils.isPresent)(this.laterPositionLearningUserCardByCardType)) {
        return this.laterPositionLearningUserCardByCardType.cardId;
      }
      if ((0, _utils.isPresent)(this.firstActiveUserCardByCardType) && this.firstActiveUserCardByCardType.id !== this.currentUserCard.id) {
        return this.firstActiveUserCardByCardType.cardId;
      }
      if ((0, _utils.isPresent)(this.laterPositionUserCard)) {
        return this.laterPositionUserCard.cardId;
      }
      return null;
    }
  }, {
    key: "lastUserCard",
    get: function get() {
      return (0, _lodash.last)(this.userCards);
    }
  }, {
    key: "numberActiveLearningCards",
    get: function get() {
      return this.userCards.filter(function (item) {
        return item.active && item.cardRule.cardType.learningCard;
      }).length;
    }
  }, {
    key: "numberActiveLearningCardsWithCardType",
    get: function get() {
      var _this3 = this;
      return this.userCards.filter(function (item) {
        return item.active && item.cardRule.cardType.learningCard && item.cardRule.cardType.slug === _this3.currentUserCard.cardRule.cardType.slug;
      }).length;
    }
  }, {
    key: "firstActiveUserCard",
    get: function get() {
      if ((0, _utils.isPresent)(this.userCards)) {
        return (0, _lodash.sortBy)(this.userCards, ['position']).find(function (item) {
          return item.active;
        });
      }
      return null;
    }
  }, {
    key: "firstActiveUserCardByCardType",
    get: function get() {
      var _this4 = this;
      if ((0, _utils.isPresent)(this.userCards)) {
        return (0, _lodash.sortBy)(this.userCards, ['position']).find(function (item) {
          return item.active && item.cardRule.cardType.slug === _this4.currentUserCard.cardRule.cardType.slug;
        });
      }
      return null;
    }
  }, {
    key: "previousUserCard",
    get: function get() {
      var _this5 = this;
      if ((0, _utils.isPresent)(this.userCards) && !this.currentUserCardIsFirstInDeck) {
        return this.userCards.find(function (item) {
          return item.position === _this5.currentPosition - 1;
        });
      }
      return null;
    }
  }, {
    key: "currentUserCardIsFirstInDeck",
    get: function get() {
      return this.currentPosition === 1;
    }
  }, {
    key: "laterPositionUserCard",
    get: function get() {
      var _this6 = this;
      if ((0, _utils.isPresent)(this.userCards)) {
        return this.userCards.find(function (item) {
          return item.position > _this6.currentPosition && item.active;
        });
      }
      return null;
    }
  }, {
    key: "laterPositionLearningUserCard",
    get: function get() {
      var _this7 = this;
      if ((0, _utils.isPresent)(this.userCards)) {
        return this.userCards.find(function (item) {
          return item.position > _this7.currentPosition && item.active && item.cardRule.cardType.learningCard;
        });
      }
      return null;
    }
  }, {
    key: "laterPositionLearningUserCardByCardType",
    get: function get() {
      var _this8 = this;
      if ((0, _utils.isPresent)(this.userCards)) {
        return this.userCards.find(function (item) {
          return item.position > _this8.currentPosition && item.cardRule.cardType.slug === _this8.currentUserCard.cardRule.cardType.slug && item.active && item.cardRule.cardType.learningCard;
        });
      }
      return null;
    }
  }, {
    key: "firstAnswerCorrectCount",
    get: function get() {
      return this.userCards.filter(function (item) {
        return item.firstAnswerCorrect;
      }).length;
    }
  }, {
    key: "setProgressCurrent",
    value: function setProgressCurrent(progressCurrent) {
      this.progressCurrent = progressCurrent;
    }
  }, {
    key: "laterPositionUserCardForCardRule",
    value: function laterPositionUserCardForCardRule(cardRuleId) {
      var _this9 = this;
      if ((0, _utils.isPresent)(this.userCards)) {
        return this.userCards.find(function (item) {
          return item.cardRule.id === cardRuleId && item.position > _this9.currentPosition && !item.skipped && ((0, _utils.isBlank)(item.score) || item.score === 0);
        });
      }
      return null;
    }
  }, {
    key: "earlierPositionUserCardForCardRule",
    value: function earlierPositionUserCardForCardRule(cardRuleId) {
      var _this0 = this;
      if ((0, _utils.isPresent)(this.userCards)) {
        return this.userCards.find(function (item) {
          return item.cardRule.id === cardRuleId && item.position <= _this0.currentPosition && !item.skipped && ((0, _utils.isBlank)(item.score) || item.score === 0);
        });
      }
      return null;
    }
  }, {
    key: "nextAvailableUserCardForCardRule",
    value: function nextAvailableUserCardForCardRule(cardRuleId) {
      var laterPositionUserCard = this.laterPositionUserCardForCardRule(cardRuleId);
      return (0, _utils.isPresent)(laterPositionUserCard) ? laterPositionUserCard : this.earlierPositionUserCardForCardRule(cardRuleId);
    }
  }, {
    key: "hasAvailableUserCardsForCardRule",
    value: function hasAvailableUserCardsForCardRule(cardRuleId) {
      return (0, _utils.isPresent)(this.userCards.filter(function (item) {
        return item.cardRule.id === cardRuleId && !item.skipped && ((0, _utils.isBlank)(item.score) || item.score === 0);
      }));
    }
  }, {
    key: "gotoCard",
    value: function gotoCard(cardId) {
      var oldPosition = this.currentPosition;
      this.currentCardId = cardId;
      var newPosition = this.currentPosition;
      if (newPosition === oldPosition) {
        this.currentUserCard.set('active', true);
      } else if (newPosition < oldPosition) {
        var userCards = this.userCards.filter(function (item) {
          return item.position >= newPosition && !item.active;
        });
        (0, _lodash.each)(userCards, function (item) {
          item.active = true;
        });
      } else {
        var _userCards = this.userCards.filter(function (item) {
          return item.position < newPosition && item.active;
        });
        (0, _lodash.each)(_userCards, function (item) {
          item.active = false;
        });
      }
      this.progressCurrent = this.userCards.filter(function (item) {
        return !item.active;
      }).length;
    }
  }, {
    key: "calculatePoints",
    value: function calculatePoints() {
      this.set('points', this.userCards.map(function (item) {
        return item.points;
      }).reduce(function (a, b) {
        return a + b;
      }, 0));
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "rating", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "currentCardId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "finished", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "designateAsFinished", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "deckId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "userId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "progressCurrent", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "progressTotal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "convertToRegistration", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "convertToPro", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "guestUser", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "registeredUser", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "proUser", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "finishedGuestUser", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "finishedRegisteredUser", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "finishedProUser", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "finishedMatch", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "points", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "lost", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "won", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "tied", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "firstPlaythrough", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "lastCardType", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "user", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "userCards", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "deck", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "opponentUserDeck", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "currentUserCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentUserCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasUserCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasUserCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentPosition", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckPercentage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckPercentage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeUserCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeUserCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numActiveUserCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numActiveUserCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numUserCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numUserCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "completedUserCardsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "completedUserCardsCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "completedLearningUserCardsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "completedLearningUserCardsCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardIdForNextActiveUserCardWithWrapping", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardIdForNextActiveUserCardWithWrapping"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardIdForNextActiveUserCardWithWrappingByCardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardIdForNextActiveUserCardWithWrappingByCardType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastUserCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastUserCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numberActiveLearningCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numberActiveLearningCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numberActiveLearningCardsWithCardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numberActiveLearningCardsWithCardType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstActiveUserCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstActiveUserCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstActiveUserCardByCardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstActiveUserCardByCardType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousUserCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousUserCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentUserCardIsFirstInDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentUserCardIsFirstInDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "laterPositionUserCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "laterPositionUserCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "laterPositionLearningUserCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "laterPositionLearningUserCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "laterPositionLearningUserCardByCardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "laterPositionLearningUserCardByCardType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstAnswerCorrectCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstAnswerCorrectCount"), _class.prototype), _class);
var _default = exports["default"] = UserDeck;